<template>
	<div class="height-100 display-flex flex-column width-100">
		<h3 class="title pl-3">{{ proc?.title }}</h3>
		<div class="flex-1 scroll-on-overflow">
			<LoaderWrapper :isLoading="loadingSelectedProcess">
				<div class="process-report-info">
					<v-simple-table v-if="proc" dense>
						<template v-slot:default>
							<thead>
								<tr>
									<th class="text-left">Run identifier</th>
									<th v-for="node in proc.nodes" :key="node.processNodeId">{{ node.title }}</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="run in proc.runs" :key="run.processRunId" class="width-100">
									<td>
										<v-chip class="ma-2 process-run-id" :title="run.processRunId" label small>
											<span class="text-truncate">
												{{ run.processRunId }}
											</span>
										</v-chip>
									</td>

									<td v-for="nodeRun in run.nodeRuns" :key="nodeRun.processNodeId">
										<v-chip class="ma-2" :color="statusColors[nodeRun.status]" text-color="white" label small>
											{{ statusLabels[nodeRun.status] }}
										</v-chip>
										<!-- awaits support from server
										<v-chip class="ma-2" color="primary" label small>
											<v-icon left> mdi-account-circle-outline </v-icon>
											Jane Doe
										</v-chip>
										-->

										<v-chip
											class="ma-2"
											color="teal"
											:href="buildTaskLogLink(nodeRun.processNodeRunId)"
											link
											text-color="white"
											label
											small
											target="_blank"
										>
											Data
											<v-icon right> mdi-eye-arrow-right </v-icon>
										</v-chip>
										<small> Updated: {{ new Date(nodeRun.modified)?.toLocaleString() }} </small>
									</td>
								</tr>
							</tbody>
						</template>
					</v-simple-table>
				</div>
			</LoaderWrapper>
		</div>
	</div>
</template>
R
<script>
import router from '@/router';
import { FlowRunStatuses } from '@ply-io/runner';
import { mapGetters, mapActions } from 'vuex';
import { loadingSelectedProcess, selectedProcess } from '@/store/modules/processReports/getters';
import { loadProcess } from '@/store/modules/processReports/actions';

export default {
	name: 'ProcessReportsInfo',
	props: ['processId'],
	computed: {
		...mapGetters([loadingSelectedProcess.fullPath, selectedProcess.fullPath]),
		loadingSelectedProcess() {
			return this[loadingSelectedProcess.fullPath];
		},
		proc() {
			return this[selectedProcess.fullPath];
		},
		statusColors() {
			return {
				[FlowRunStatuses.Started]: 'light-blue',
				[FlowRunStatuses.Done]: 'green',
				[FlowRunStatuses.NotifSent]: 'purple',
				[FlowRunStatuses.NotifResumed]: 'blue',
				[FlowRunStatuses.Failed]: 'red',
				[FlowRunStatuses.Canceled]: 'orange',
			};
		},
		statusLabels() {
			return {
				[FlowRunStatuses.Pending]: 'Pending',
				[FlowRunStatuses.Started]: 'Started',
				[FlowRunStatuses.Canceled]: 'Canceled',
				[FlowRunStatuses.Failed]: 'Error',
				[FlowRunStatuses.Done]: 'Done',
				[FlowRunStatuses.NotifSent]: 'Notification Sent',
				[FlowRunStatuses.NotifResumed]: 'Notification Clicked',
			};
		},
	},
	methods: {
		...mapActions([loadProcess.fullPath]),
		buildTaskLogLink(flowRunId) {
			return router.resolve({ name: 'TaskLogInfo', params: { flowRunId } }).href;
		},
	},
	async created() {
		if (!this.proc) {
			await this[loadProcess.fullPath](this.processId);
		}
	},
};
</script>
<style scoped>
.process-run-id {
	width: 100px;
}
.process-report-info tr {
	border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}
.process-report-info td {
	border: none !important;
}
</style>
